import { render } from "./colSet.vue?vue&type=template&id=98cdb01e&scoped=true"
import script from "./colSet.vue?vue&type=script&lang=js"
export * from "./colSet.vue?vue&type=script&lang=js"

import "./colSet.vue?vue&type=style&index=0&id=98cdb01e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98cdb01e"]])

export default __exports__